module.exports = {
  email: 'junhanzv@uchicago.edu',

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'News',
      url: '/#news',
    },
    {
      name: 'Publications',
      url: '/#publications',
    },
    {
      name: 'Mentors, Mates and Mentees',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#D64FAF',   // main accent
    navy: '#0D0311',    // main background
    darkNavy: '#08020B',
  },


  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
